import * as React from 'react';
import { findIndex, isUndefined, isEmpty } from 'lodash';
import { isEmptyObject } from 'jquery';
import * as Utils from '../Utils';
import Sidebar from './Sidebar';
import Actions from './Actions';
import Content from './Content';
import { I18NString, tr, sleep, goToAnchor } from '../Utils';
import {
  ControlValueDispatcher,
  ValidationError,
} from '../controls/extensions/Dispatcher';
import { ISectionSchema } from '../Section';
import Progress, { countProgress } from './Progress';
import {
  ControlErrorListItem,
  IControlError,
  IControlSchema,
} from '../Controls';
import Loader from 'react-loader-advanced';
import {
  ErrorField,
  isGroupCheck,
  onValidate,
  validateControl,
} from '../controls/standart/validate';
import RuleManager from '../../services/RulesManager';
import ConfirmModal from './ConfirmModal';
import { IGroupSchema } from '../controls/standart/Group';
import { IPanelSchema } from '../controls/standart/Panel';
import equal from 'fast-deep-equal';

import { ICalendarSchema } from '../controls/standart/Calendar/Calendar';

import { Dictionary } from '../../types/Dictionary';

export const dots = (
  <span className="loader">
    <span className="loader__item" />
    <span className="loader__item" />
    <span className="loader__item" />
  </span>
);

interface FormState {
  form: any;
  forms: Array<any>;
  loaders: any;
  values: Array<any>;
  section: string;
  listUserForms: Array<any>;
  checkedPanel: Array<string>;
  user: any;
  companies: Array<any>;
  countToSend: number;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
  readonly?: boolean;
  status?: number;
  formUid?: string;
  process_id?: number;
  form_type?: string;
  initData?: any;
}

interface Props {
  schema: FormState;
  loaders: any;
  noTitle?: boolean;
  initData?: any;
}

interface State {
  errorField: ErrorField;
  loader: boolean;
  func: (open) => void;
  anchorTo: {
    sectionId: string;
    controlId: string;
  };
  anchoredTo: {
    sectionId: string;
    controlId: string;
  };
}

interface RequestProps {
  onRevoke: () => void;
  onDraft: () => void;
  isRemovePanelBlock: any;
  setFileValue: any;
  getFileUrl: any;
  deleteFileValue: any;
  hasRemoveBlock: any;
  sendDocument: any;
  sendPDF: any;
  deleteValues: any;
  cloneRequest: any;
  sendValues: any;
  sendAdditional: any;

  setSection: any;
  getForms: any;
  addValue: (id: string, value: any, refresh: boolean) => void;
  addFile: any;
  // checkedPanel: (panelId: string, checked: boolean, error: IControlError | undefined) => void,
  incrimentToSend: any;
  copyValue: any;
  recal: any;
  markVisited: (id: string) => void;
  setError: (id: string, error: IControlError) => void;
  markAllVisited: () => void;
}

interface SectionPercent {
  countRequired: number;
  countNotEmpty: number;
}

//class SubstActions extends Component<ActionsProps, null>{}

function recalPercentToSection(
  controls: Array<IControlSchema>,
  values: Array<any>,
  persent: SectionPercent,
  permissiblePanelIDs: Array<string>,
) {
  for (let ctrl of controls) {
    const valueIdx = findIndex(values, (val: any) => val.controlid === ctrl.id);

    if (
      !ctrl.hasOwnProperty('controls') &&
      (isUndefined(ctrl.visible) || ctrl.visible)
    ) {
      let visible = false;
      if (ctrl['visible'] === true || typeof ctrl['visible'] === 'undefined') {
        visible = true;
      } else if (ctrl['visible'] && ctrl['visible'].length > 0) {
        let k = ctrl.visible.length;
        while (k--) {
          const linkedValue = values.filter(
            (value) =>
              String(value.controlid) === String(ctrl.visible[k].field),
          );
          if (
            linkedValue &&
            linkedValue.length === 1 &&
            ctrl.visible[k].rule === 'has_value' &&
            ctrl.visible[k].values
              .map((value) => String(value))
              .indexOf(String(linkedValue[0].value.label)) > -1
          ) {
            visible = true;
          }
        }
      }

      if (ctrl.required && visible) {
        persent.countRequired++;
      }
      if (valueIdx > -1 && ctrl.required && visible) {
        if (
          ctrl.type.toUpperCase() === 'CALENDAR' &&
          (ctrl as ICalendarSchema).finishDate !== null
        ) {
          const value = values[valueIdx].value;
          if (!isEmpty(value.beginDate) && !isEmpty(value.finishDate)) {
            persent.countNotEmpty++;
          }
        } else {
          persent.countNotEmpty++;
        }
      }
    } else if (
      isGroupCheck(ctrl as IGroupSchema | IPanelSchema, values[valueIdx])
    ) {
      //dynamic
      if (
        ctrl.type.toUpperCase() === 'PANEL' &&
        valueIdx > -1 &&
        !isEmpty(values[valueIdx].value.rows)
      ) {
        const rows = values[valueIdx].value.rows;
        for (let row of rows) {
          for (let controlRow of row.controls) {
            const index = findIndex(
              values,
              (val: any) => val.controlid === controlRow.id,
            );
            const idxCtrl = findIndex(
                ctrl['controls'],
                (obj: any) => obj.id === controlRow.name,
              ),
              childControl = ctrl['controls'][idxCtrl];

            if (childControl.required) persent.countRequired++;

            if (index > -1 && childControl.required) persent.countNotEmpty++;
          }
        }
      }

      recalPercentToSection(
        ctrl['controls'],
        values,
        persent,
        permissiblePanelIDs,
      );
    } else if (
      ctrl.type.toUpperCase() === 'DYNAMICGRIDPANEL' &&
      valueIdx > -1
    ) {
      for (const element of values[valueIdx].value) {
        persent.countRequired += element.items.length;
        for (const item of element.items) {
          const exist = values.some((t) => t.controlid === item.name);
          if (exist) {
            persent.countNotEmpty++;
          }
        }
      }
    }
  }
}

//35867
function visibleControls(state: any): Array<ISectionSchema> {
  const { form, values } = state;
  const sections = [...form.sections];
  // TODO: Rebuld manager (Видимость полей обрабатывается в Content.tsx)
  const manager = new RuleManager();
  manager.run(sections, values);

  return sections;
}

function getSelection(
  sections: Array<ISectionSchema>,
  values: any,
  section: string,
): ISectionSchema {
  const index = findIndex(sections, (sec: any) => sec.id === section);

  return sections[index];
}

function calcPercentSidebar(
  sections: Array<ISectionSchema>,
  values: any,
  checkedPanel: any,
) {
  return sections.map((sect: ISectionSchema): any => {
    return {
      id: sect.id,
      title: sect.title,
      percent: getPercent(sect, values, checkedPanel),
    };
  });
}

function getPercent(
  section: ISectionSchema,
  values: any,
  checkedPanel: any,
): number {
  if (!isUndefined(values) && values && values.length > 0) {
    let persent = {
      countRequired: 0,
      countNotEmpty: 0,
    };
    recalPercentToSection(section.controls, values, persent, checkedPanel);

    return persent.countRequired > 0
      ? parseInt(
          ((persent.countNotEmpty / persent.countRequired) * 100).toString(),
          0,
        )
      : 0;
  }

  return 0;
}

class Request extends React.Component<Props & RequestProps, State> {
  modal: ConfirmModal;

  constructor(props) {
    super(props);
    this.state = {
      errorField: null,
      loader: false,
      func: null,
      anchoredTo: {
        controlId: undefined,
        sectionId: undefined,
      },
      anchorTo: {
        controlId: undefined,
        sectionId: undefined,
      },
    };

    this.onValidateAndSend = this.onValidateAndSend.bind(this);
    this.onReportPDF = this.onReportPDF.bind(this);
    this.onSelected = this.onSelected.bind(this);
    this.onDocument = this.onDocument.bind(this);
    this.onRevoke = this.onRevoke.bind(this);
    this.onDraft = this.onDraft.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onCopy = this.onCopy.bind(this);
  }

  componentWillMount() {
    // const { process_id, form_type } = this.props.params;
    // const { user } = this.props;
    // if (typeof user.isAuth === 'undefined' || !user.isAuth) this.props.auth();

    Utils.initLanguage('RU');

    this.dispather = new ControlValueDispatcher();
    this.dispather.addControlValue = this.addControlValue.bind(this);
    this.dispather.addFile = this.addFileValue.bind(this);
    this.dispather.addControlRefresh = this.addControlRefresh.bind(this);
    this.dispather.copyValue = this._handlerCopyValue.bind(this);
    this.dispather.error = this.frontError.bind(this);
    this.dispather.controlVisited = this.controlVisited.bind(this);
    this.dispather.pullValue = this.pullValue.bind(this);
    this.dispather.pullTableRows = this.pullTableRows.bind(this);

    this.dispather.isRemovePanelBlock = this.props.isRemovePanelBlock;
    this.dispather.setFileValue = this.props.setFileValue;
    this.dispather.getFileUrl = this.props.getFileUrl;
    this.dispather.deleteFileValue = this.props.deleteFileValue;
    this.dispather.hasRemoveBlock = this.props.hasRemoveBlock;
  }

  controlVisited(id: string) {
    this.props.markVisited(id);
  }
  pullValue(control_id: string) {
    const values = this.props.schema.values.filter(
      (v) => v.controlid == control_id,
    );
    if (!isEmpty(values)) {
      return values[0].value;
    }
    return null;
  }
  pullTableRows(control_id: string, field_id: string): Array<string> {
    const values = this.props.schema.values.filter(
      (v) => v.controlid == control_id,
    );
    if (!isEmpty(values)) {
      try {
        let array =
          typeof values[0].value === 'string'
            ? JSON.parse(values[0].value)
            : values[0].value;
        return array.map((obj, idx) => {
          return obj[field_id];
        });
      } catch (e) {
        return [];
      }
    }
    return [];
  }
  frontError(
    id: string,
    value: string,
    error: ValidationError | undefined,
    skipCommonValidation: boolean,
  ) {
    const control = this.findControl(id);
    const { errors } = this.props.schema;
    if (!control) {
      console.error(`control with id ${id} was not found`);
      return;
    }

    const existingError = errors[control.id];
    if (existingError && !existingError.isFrontValidation) {
      return;
    }

    if ((control as any).disabled && !control.visible) {
      this.props.setError(id, undefined);
      return;
    }

    if (!error && !skipCommonValidation) {
      this.checkAndSetControlErrors(id, value, error, false);
      return;
    }

    this.props.setError(
      id,
      error && {
        isFrontValidation: true,
        message: error.message,
        isError: true,
      },
    );
  }

  componentDidUpdate(
    prevProps: Readonly<Props & RequestProps>,
    prevState: Readonly<State>,
  ): void {
    if (
      !equal(this.state.anchorTo, this.state.anchoredTo) &&
      this.state.anchorTo.controlId
    ) {
      if (goToAnchor(this.state.anchorTo.controlId)) {
        this.setState({ anchoredTo: this.state.anchorTo });
      }
    }

    if (this.props.schema.section !== prevProps.schema.section) {
      this.clearAnchor();
    }
  }

  private clearAnchor() {
    this.setState({
      anchoredTo: { sectionId: undefined, controlId: undefined },
      anchorTo: { sectionId: undefined, controlId: undefined },
    });
  }

  private findControl(controlId: string): IControlSchema | undefined {
    return this.props.schema.form.sections
      .map((s) => this.findControlInArray(controlId, s.controls))
      .find((s) => s);
  }

  private findControlInArray(
    controlId: string,
    controls: any[],
  ): IControlSchema | undefined {
    return controls
      .map((c) => {
        if (c.id === controlId) {
          return c;
        }
        if (c.controls) {
          return this.findControlInArray(controlId, c.controls);
        }

        return undefined;
      })
      .find((s) => s);
  }

  private dispather: ControlValueDispatcher;

  protected tr: (message: I18NString) => string = tr;

  _handlerCopyValue(sourceId: string, targetId: string) {
    this.props.copyValue(sourceId, targetId);
  }

  onSelected(id: string) {
    this.props.setSection(id);
  }

  addControlValue(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError,
  ) {
    this.checkAndSetControlErrors(id, value, error, false);
    this.props.addValue(id, value, false);
  }

  addControlRefresh(id: string, value: any, error: ValidationError) {
    this.checkAndSetControlErrors(id, value, error, false);
    this.props.addValue(id, value, true);
  }

  checkAndSetControlErrors(
    id: string,
    value: any,
    error: ValidationError,
    validateEmptyRequired: boolean,
  ) {
    let errors: ErrorField[] = [];
    if (!error || !error.message) {
      errors = this.checkForErrors(id, value, error, validateEmptyRequired);
      if (errors.filter((e) => e.controlId === id).length <= 0) {
        errors.push({
          controlId: id,
          control: this.findControl(id),
          error: undefined,
        });
      }
    } else {
      errors.push({
        controlId: id,
        control: this.findControl(id),
        error: {
          isFrontValidation: true,
          message: error.message,
        },
      });
    }
    this.setState({ errorField: errors.find((e) => !!e.error) });
    this.setMultipleErrors(errors);
  }

  checkForErrors(
    id: string,
    value: any,
    error: ValidationError,
    validateEmptyRequired: boolean,
  ): ErrorField[] {
    const control = this.findControl(id);
    if (control) {
      const values = this.props.schema.values
        ? this.props.schema.values.filter((v) => v.controlid !== id)
        : [];
      if (!isEmpty(value)) {
        values.push({ controlid: id, value });
      }
      const controlError: IControlError = error && {
        isError: true,
        isFrontValidation: true,
        message: error.message,
      };
      const existingErrors = {
        ...this.props.schema.errors,
        [id]: controlError,
      };
      const errors = Array.from(
        validateControl(
          {
            ...control,
            value,
          } as any,
          values,
          this.props.schema.form,
          validateEmptyRequired,
          existingErrors,
        ),
      );
      return errors;
    }
    return [];
  }

  addFileValue(id: string, value: any, valid: boolean) {
    const { errorField } = this.state;

    if (errorField && errorField.controlId === id) {
      this.setState({ errorField: undefined });
    }

    this.props.addFile(id, value);
  }

  addCheckedPanel(panelId: string, checked: boolean) {}

  /* Кнопка возврат */
  onRevoke() {
    const { onRevoke } = this.props;
    if (typeof onRevoke !== 'undefined') onRevoke();
  }

  /* Кнопка возврат */
  onDraft() {
    const { onDraft } = this.props;
    if (typeof onDraft !== 'undefined') onDraft();
  }

  /*Отправить документы*/
  onDocument() {
    const { onRevoke, sendDocument } = this.props;
    const { form, values } = this.props.schema;
    const self = this;

    this.props.markAllVisited();
    if (!this.validateForm(form, values, true)) {
      return;
    }

    self.setState({ loader: true });
    // TODO: Need to check
    console.log('Request/index.tsx sendDocument need to check');
    sendDocument({
      success: () => {
        this.props.getForms();
        self.setState({ loader: false });
        alert('Документы отправлены');
        onRevoke();
      },
      error: (error, response) => {
        self.setState({ loader: false });
        if (!isUndefined(response)) {
          console.log('error', response);
          try {
            const result = JSON.parse(response);
            alert(result.message);
          } catch (e) {
            alert('Не удалось выполнить отправку');
          }
        } else {
          alert('Не удалось выполнить отправку');
        }
      },
    });
  }

  /*Получить PDF*/
  onReportPDF() {
    this.props.recal();
    this.props.markAllVisited();
    // props.recal() может поменять стейт и эти изменения должны быть видны дальше.
    // Вообще стоило бы какие-нибудь саги притащить, но времени нет.
    const { schema, onRevoke, sendPDF } = this.props;
    const { form } = schema;
    const self = this;

    if (!this.validateForm(form, schema.values)) {
      return;
    }

    const action = (open) => {
      if (open) {
        this.setState({ loader: true });
        // TODO: Need to check
        console.log('Request/index.tsx sendPDF need to check');
        sendPDF({
          success: () => {
            self.setState({ loader: false });
            alert('Ваш запрос на формирование PDF обрабатывается');
            onRevoke();
          },
          error: (_, response) => {
            self.setState({ loader: false });
            if (!isUndefined(response)) {
              const result = JSON.parse(response);
              if (result.errors[0].error.SumGrant) {
                this.props.setError('SumGrant', {
                  isFrontValidation: false,
                  message: result.errors[0].error.SumGrant,
                  isError: true,
                });
                this.props.setSection('GeneralInformation');
                this.props.incrimentToSend();
                return;
              } else {
                alert(result.errors[0].error.message);
              }
            } else {
              alert('Не удалось выполнить отправку');
            }
          },
        });
      }
    };
    this.setState({ func: action });
    this.modal.show();
  }

  onDelete() {
    const { onRevoke, deleteValues } = this.props;
    const self = this;
    if (confirm('Удалить заявку?')) {
      this.setState({ loader: true });
      // TODO: Need to check
      console.log('Request/index.tsx onDelete need to check');
      deleteValues({
        success: () => {
          self.setState({ loader: false });
          onRevoke();
        },
        error: () => {
          self.setState({ loader: false });
          alert('Произошла ошибка в во время удаления заявки');
        },
      });
    }
  }

  onCopy() {
    const { onRevoke, cloneRequest } = this.props;
    const self = this;

    if (confirm('Копировать заявку?')) {
      this.setState({ loader: true });
      // TODO: Need to check
      console.log('Request/index.tsx onCopy need to check');
      cloneRequest({
        success: () => {
          self.setState({ loader: false });
          onRevoke();
        },
        error: () => {
          self.setState({ loader: false });
          alert('Произошла ошибка в во время копирования заявки');
        },
      });
    }
  }

  onValidateAndSend() {
    this.props.recal();
    this.props.markAllVisited();
    // props.recal() может поменять стейт и эти изменения должны быть видны дальше.
    // Вообще стоило бы какие-нибудь саги притащить, но времени нет.
    const { schema } = this.props;
    const self = this;

    const { form, values } = schema;

    if (!this.validateForm(form, values, true)) {
      return;
    }

    const action = (open) => {
      const { onRevoke, sendValues } = this.props;
      if (open) {
        this.setState({ loader: true });
        // TODO: Need to check
        console.log('Request/index.tsx Validate and Send need to check');
        sendValues({
          success: () => {
            self.setState({ loader: false });
            alert('Ваша заявка принята');
            onRevoke();
          },
          error: (error, response) => {
            self.setState({ loader: false });
            if (!isUndefined(response)) {
              const result = JSON.parse(response);
              if (result.errors[0].error.SumGrant) {
                this.props.setError('SumGrant', {
                  isFrontValidation: false,
                  message: result.errors[0].error.SumGrant,
                  isError: true,
                });

                this.props.setSection('GeneralInformation');
                this.props.incrimentToSend();
                return;
              } else {
                alert(result.errors[0].error.message);
              }
            } else {
              alert('Не удалось выполнить отправку');
            }
          },
        });
      }
    };
    this.setState({ func: action });
    this.modal.show();
  }

  onAddition = () => {
    const { onRevoke, sendAdditional } = this.props;
    const { form, values } = this.props.schema;
    const self = this;
    const section = form.sections.find((t) => t.id === 'AdditionalRequest');

    const validationResult = this.validateSection(section, form, values, true);
    if (validationResult && validationResult.length > 0) {
      this.setMultipleErrors(validationResult);
      const actualErrors = validationResult.filter((v) => !!v.error);
      if (actualErrors[0]) {
        this.scrollToSectionError(actualErrors[0], section.id);
        return;
      }
    }

    self.setState({ loader: true });
    // TODO: Need to check
    console.log('Request/index.tsx onAddition need to check');
    sendAdditional({
      success: () => {
        self.setState({ loader: false });
        alert('Дозапрос отправлен');
        onRevoke();
      },
      error: (error, response) => {
        self.setState({ loader: false });
        if (!isUndefined(response)) {
          const result = JSON.parse(response);
          alert(result.errors[0].error.message);
        } else {
          alert('Не удалось выполнить отправку');
        }
      },
    });
  };

  private isPdf(): boolean {
    const { values } = this.props.schema;
    const requestPdf = findIndex(
      values,
      (obj: any) => obj.controlid == 'RequestGrant',
    );

    return requestPdf > -1;
  }

  getCheckedPanels(): Array<string> {
    const { form, values } = this.props.schema;
    const arr = [];
    for (let section of form.sections) {
      for (let control of section.controls) {
        if (control.hasOwnProperty('controls')) {
          const valueIdx = findIndex(
            values,
            (val: any) => val.controlid === control.id,
          );
          if (
            isGroupCheck(
              control as IGroupSchema | IPanelSchema,
              values[valueIdx],
            )
          ) {
            arr.push(control.id);
          }
        }
      }
    }
    return arr;
  }

  collectSectionErrors(section: ISectionSchema): ControlErrorListItem[] {
    if (!section) {
      return [];
    }
    const errors = this.props.schema.errors;
    function* collectErrors(
      controls: IControlSchema[],
    ): Iterable<ControlErrorListItem> {
      for (let control of controls) {
        const controlError = errors[control.id];
        if (controlError) {
          const error: ControlErrorListItem = {
            ...controlError,
            controlId: control.id,
          };
          yield error;
        }

        if ((control as any).controls) {
          yield* collectErrors((control as any).controls);
        }
      }
    }

    return Array.from(collectErrors(section.controls));
  }

  render() {
    const { schema, loaders, noTitle, initData } = this.props;

    if (isEmptyObject(schema.form) === false) {
      let form = schema.form;
      let readonly = schema.readonly;
      let sct = visibleControls(schema);

      let valuesSection = getSelection(sct, schema.values, schema.section);
      let sections = calcPercentSidebar(
        sct,
        schema.values,
        schema.checkedPanel,
      );

      let errorField = this.collectSectionErrors(valuesSection);
      if (this.state.errorField && this.state.errorField.error) {
        errorField = [
          {
            controlId: this.state.errorField.controlId,
            message: this.state.errorField.error.message,
            isError: true,
            isFrontValidation: this.state.errorField.error.isFrontValidation,
          },
          ...errorField,
        ];
      }
      const firstSectionErrorId = errorField[0] && errorField[0].controlId;

      return (
        <div id="content" className="nopad">
          <Loader
            show={typeof loaders.form !== 'undefined'}
            message={dots}
            backgroundStyle={{ backgroundColor: 'rgba(255,255,255,1)' }}
          >
            <div className="reportbox">
              <div className="reportbox-content-row">
                {this.props.schema.form.sections.length > 1 && (
                  <div className="reportbox-sidebar">
                    <div className="reportbox-sidebar-menu">
                      <Sidebar
                        items={sections}
                        status={schema.status}
                        value={this.props.schema.section}
                        isClose={schema.form.close && schema.status === 0}
                        onSelected={this.onSelected}
                      ></Sidebar>
                    </div>
                  </div>
                )}
                <div className="reportbox-content-viewport">
                  <Content
                    section={valuesSection}
                    disableNumber={this.props.schema.form.enabled}
                    status={schema.status}
                    values={schema.values}
                    countToSend={schema.countToSend}
                    readonly={readonly}
                    visited={this.props.schema.visited}
                    allVisited={this.props.schema.allVisited}
                    errors={this.props.schema.errors}
                    firstErrorId={firstSectionErrorId}
                    dispatcher={this.dispather}
                    noTitle={noTitle}
                    initData={initData}
                  ></Content>
                </div>
              </div>
              <Progress
                sections={form.sections}
                checkPanel={this.getCheckedPanels()}
                sectionPercent={sections}
              />
              <Actions
                onPDF={this.onReportPDF}
                schema={form}
                status={schema.status}
                onSend={this.onValidateAndSend}
                onCopy={this.onCopy}
                onDraft={() => this.onDraft}
                onDocument={this.onDocument}
                onRevoke={this.onRevoke}
                onDelete={this.onDelete}
                onAddition={this.onAddition}
                isPdf={this.isPdf()}
                isVisible={isUndefined(readonly) ? true : !readonly}
                progress={countProgress({
                  sections: form.sections,
                  checkPanel: this.getCheckedPanels(),
                  sectionPercent: sections,
                })}
              />
            </div>
          </Loader>
        </div>
      );
    }

    return <div></div>;
  }

  setMultipleErrors(errorFields: ErrorField[]) {
    errorFields.forEach((e) =>
      this.props.setError(
        e.controlId,
        e.error && {
          isFrontValidation: true,
          isError: true,
          message: e.error.message,
        },
      ),
    );
  }

  private validateForm(
    form: any,
    values,
    enabledControlsOnly: boolean = false,
  ): boolean {
    let firstInvalidSection: { sectionId: string; errorField: ErrorField } =
      undefined;
    for (let section of form.sections) {
      const validationErrors = this.validateSection(
        section,
        form.sections,
        form,
        values,
        enabledControlsOnly,
      );
      if (validationErrors) {
        this.setMultipleErrors(validationErrors);
        const realErrors = validationErrors.filter((e) => e.error);
        if (realErrors.length > 0 && !firstInvalidSection) {
          firstInvalidSection = {
            sectionId: section.id,
            errorField: realErrors[0],
          };
        }
      }
    }

    if (firstInvalidSection) {
      this.scrollToSectionError(
        firstInvalidSection.errorField,
        firstInvalidSection.sectionId,
      );
      alert(firstInvalidSection.errorField.error.message);
      return false;
    }

    return true;
  }

  private validateSection(
    section: any,
    all_sections: Array<any>,
    form: any,
    values,
    enabledControlsOnly: boolean = false,
  ): ErrorField[] {
    let errorFields = Array.from(
      onValidate(
        section.controls,
        values,
        form,
        true,
        this.props.schema.errors,
      ),
    );
    if (enabledControlsOnly) {
      errorFields = errorFields.filter(
        (errorField) => !errorField.control.disabled,
      );
    }
    if (section.id == 'ProjectBudget') {
      let val_13_2_sum = 0;
      let val_2_5 = 0;
      let val_2_6 = 0;
      let error_ctrl_13 = null;
      for (let control of section.controls) {
        if (control.id == 'FixedTableEstimate') {
          error_ctrl_13 = control;
          let control_values =
            typeof control.value === 'string'
              ? JSON.parse(control.value)
              : control.value;
          if (control_values) {
            for (let value of control_values) {
              if (value.internal_id == 'TotalExpences') {
                val_13_2_sum = value.pos_value;
              }
            }
          }
        }
      }
      for (var s of all_sections) {
        if (s.id == 'MemberName') {
          for (let control of s.controls) {
            if (control.id == 'SumGrant') {
              val_2_5 = parseFloat(control.value);
            }
            if (control.id == 'SumInvest') {
              val_2_6 = parseFloat(control.value);
            }
          }
          break;
        }
      }

      if (val_13_2_sum != val_2_5 + val_2_6) {
        errorFields.push({
          controlId: 'FixedTableEstimate',
          control: error_ctrl_13,
          error: {
            message:
              'Сумма проекта (грант+соинвестиции) не совпадает с представленной сметой. Проверьте корректность заполнения п.2.5,2.6 и 13.2',
            isFrontValidation: true,
          },
        });
      } else {
        errorFields = errorFields.filter((item) => {
          return item.controlId != 'FixedTableEstimate';
        });
      }
      return errorFields;
    }
    if (section.id == 'BusinessModel') {
      let years = [
        '2017',
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        'Total',
      ];
      let sum_8_2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let sum_8_3 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let error_ctrl_8 = null;
      let data_avali = true;
      for (let control of section.controls) {
        if (control.id == 'SalesYear') {
          error_ctrl_8 = control;
          let sales_value =
            typeof control.value === 'string'
              ? JSON.parse(control.value)
              : control.value;
          if (sales_value) {
            for (let v1 of sales_value) {
              if (v1.spec_summary) continue;
              for (let i = 0; i < years.length; i++) {
                if (v1['sale' + years[i]]) {
                  let cur = Utils.parseFloatCommaDot(v1['sale' + years[i]]);
                  if (!isNaN(cur)) {
                    sum_8_2[i] += cur;
                  }
                }
              }
            }
          } else {
            data_avali = false;
          }
        }
        if (control.id == 'SalesCountry') {
          let sales_value =
            typeof control.value === 'string'
              ? JSON.parse(control.value)
              : control.value;
          if (sales_value) {
            for (let v2 of sales_value) {
              if (v2.spec_summary) continue;
              for (let i = 0; i < years.length; i++) {
                var field = 'sale' + years[i] + 'country';
                if (years[i] == 'Total') {
                  field = 'saleTotalCountry';
                }
                if (v2[field]) {
                  let cur = Utils.parseFloatCommaDot(v2[field]);
                  if (!isNaN(cur)) {
                    sum_8_3[i] += cur;
                  }
                }
              }
            }
          } else {
            data_avali = false;
          }
        }
      }
      for (let i = 0; i < years.length; i++) {
        sum_8_2[i] = Utils.roundCurrency(sum_8_2[i]);
        sum_8_3[i] = Utils.roundCurrency(sum_8_3[i]);
        if (sum_8_2[i] != sum_8_3[i]) {
          let name_part = years[i];
          if (name_part == 'Total') {
            name_part = 'Итого';
          }
          errorFields.push({
            controlId: 'SalesYear',
            control: error_ctrl_8,
            error: {
              message:
                'Внимание! Проверьте итоговые значения по столбцам в таблицах “Факт и Прогноз продаж по направлениям” и "Факт и Прогноз продаж по странам”, они должны совпадать (' +
                name_part +
                ')',
              isFrontValidation: true,
            },
          });
          return errorFields;
        }
      }

      errorFields = errorFields.filter((item) => {
        return item.controlId != 'SalesYear';
      });
    }
    return errorFields;
  }

  scrollToSectionError(errorField: ErrorField, sectionId: string) {
    this.setState({ errorField: errorField });
    this.props.incrimentToSend();
    if (
      this.props.schema.section === sectionId &&
      goToAnchor(errorField.controlId)
    ) {
      const anchored = {
        controlId: errorField.controlId,
        sectionId: sectionId,
      };
      this.setState({
        anchorTo: anchored,
        anchoredTo: anchored,
      });
    } else {
      this.props.setSection(sectionId);
      this.setState({
        anchorTo: {
          controlId: errorField.controlId,
          sectionId: sectionId,
        },
        errorField,
      });
    }
  }
}

export default Request;
